<template>
  <div class="text-center" >
    <v-switch :disabled="!cmpPermisos" hide-details class="mx-auto text-center cont-sw" :label="valor ? 'SI' : 'NO'" v-model="valor" :loading="bLoad" @change="onCambiarValor"></v-switch>
  </div>  
</template>
<script>
import mixinGridComponenteCelda from "@/mixins/GridComponenteCelda.js"
import axiosServices from '@/services/axiosServices.js'

export default {
name: "CeldaSwitch",
mixins: [mixinGridComponenteCelda],
data() {
  return {
    bLoad: false,
  }
},
mounted () {
  this.valor = this.texto === '1' 
  // console.log('CeldaSwitch oDataparens, campo, sTabla', this.oDataParent, this.sCampo, this.sTabla )
},
methods: {
  async onCambiarValor() {
    this.bLoad = true
    const aDataWhere = {}
    this.sIdTable.split(',').forEach(sItem =>{
      aDataWhere[sItem] = (this.oDataParent[sItem])
    })
    this.sIdTable

    const oBody = {
      sTable  : this.sTabla,
      sCampo  : this.sCampo,
      sValor  : this.valor ? 1 : 0,
      aCampos : aDataWhere
    }
    const axiosChange = await axiosServices.putConfiguration('/pGrids_changeCampo', oBody , true , `sTable=${this.sTabla}` )
    if(axiosChange.nStatusCode === 200 && !axiosChange.aData ) {
      this.valor = !this.valor
      this.$store.dispatch('notificaciones/SetColor','error')
      this.$store.dispatch('notificaciones/SetMensaje','Notificación: No se pudo realizar el cambio')
    } else {
      this.$store.dispatch('notificaciones/SetColor','success')
      this.$store.dispatch('notificaciones/SetMensaje','Notificación: Cambio realizado')
    }
    this.$store.dispatch('notificaciones/ShowNotificacion',true); 
    this.bLoad = false
    
  }
},
};

</script>

<style lang="scss" scoped>
.cont-sw{
width: 100px;
margin: 0;
padding: 0;
}
</style>